import React from 'react';
import { TaskCreateTask } from '../../tasks/form/create/ws/TaskCreateTask';
import ConfirmModal from '../../../shared/components/confirm-modal/ConfirmModal';
import CardHeader from '../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import CardBody from '../../../shared/components/CardBody';
import HeaderSearchRefreshFilterOptions from '../../../shared/components/HeaderSearchRefreshFilterOptions';
import Row from '../../../shared/components/Row';
import Card from '../../../shared/components/Card';
import { HeaderFilterOptions } from './components/HeaderFilterOptions';
import { MonthlyPresenceTable } from './components/table/MonthlyPresenceTable';
import { MonthlyPresenceFilters } from './MonthlyPresenceFilters';
import { YearListTask } from './webservices/year-list/YearListTask';
import { YearListRequest } from './webservices/year-list/YearListRequest';
import { MonthListRequest } from './webservices/month-list/MonthListRequest';
import { MonthListTask } from './webservices/month-list/MonthListTask';
import { MonthlyPresenceSearchRequest } from './webservices/monthly-presence-search/MonthlyPresenceSearchRequest';
import { MonthlyPresenceSearchTask } from './webservices/monthly-presence-search/MonthlyPresenceSearchTask';
import { PsPresence } from '../management/PsPresence';
import { MonthlyPresenceSorting } from './MonthlyPresenceSorting';
import { CurrentUser } from '../../../shared/model/CurrentUser';
import { connect } from 'react-redux';
import { MonthlyPresenceDownloadRequest } from './webservices/monthly-presence-download/MonthlyPresenceDownloadRequest';
import GenericRequest, { METHOD_POST } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import cookie from 'react-cookies';
import { AUTH_TOKEN } from '../../../shared/utils/CookiesManager';
import Alert from 'react-s-alert';
import { TaskCreateRequest } from '../../tasks/form/create/ws/TaskCreateRequest';

const OptionsMore = {
    NONE: '',
    DOWNLOAD: 'DOWNLOAD',
    CREATE_TASK: 'CREATE_TASK',
};

class MonthlyPresence extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            days: [],
            years: [],
            months: [],
            filters: MonthlyPresenceFilters.fromDefault(),
            sorting: MonthlyPresenceSorting.fromDefault(),
            loading: false,
            presences: [],
            moreOptionSelected: OptionsMore.NONE,
            showCreateTaskConfirmModal: false,
        };
    }

    componentDidMount() {
        this.fetchYears();
    }

    componentDidUpdate(_, prevState) {
        const { filters: prevFilters } = prevState;
        const { filters: nextFilters } = this.state;
        const shouldSearchAgain = prevFilters !== nextFilters;

        if ( shouldSearchAgain ) {
            if ( nextFilters.canSearch() ) {
                this.searchMonthlyPresences();
            } else {
                this.setState({
                    days: [],
                    presences: [],
                });
            }
        }
    }

    showCreateTaskConfirmModal = () => {
        this.setState({ showCreateTaskConfirmModal: true });
    };

    hideCreateTaskConfirmModal = () => {
        this.setState({ showCreateTaskConfirmModal: false });
    };

    render() {
        const {
            days,
            years,
            months,
            filters,
            loading,
            sorting,
            presences,
            showCreateTaskConfirmModal,
        } = this.state;

        return (
            <React.Fragment>
                <Row>
                    <Card loading={loading}>
                        <CardHeader
                            title={I18nUtils.tr('TR_TRABAJADORES').toUpperCase()}
                            rightOptions={(
                                <HeaderSearchRefreshFilterOptions
                                    onRefresh={this.searchMonthlyPresences}
                                    onSearch={this.search}
                                    enableFilter={false}
                                    moreOptions={this.moreOptions()}
                                />
                            )}
                        />
                        <CardBody>
                            <div>
                                <HeaderFilterOptions
                                    years={years}
                                    months={months}
                                    filters={filters}
                                    handleChangeYearFilter={this.selectYearFilter}
                                    handleChangeMonthFilter={this.selectMonthFilter}
                                    handleSelectWorkFilter={this.selectWorkFilter}
                                    handleSelectOutsourceFilter={this.selectOutsourceFilter}
                                />
                                <hr/>
                                {
                                    filters.canSearch() ? (
                                        <MonthlyPresenceTable
                                            days={days}
                                            sorting={sorting}
                                            presences={presences}
                                            onSortByColumn={this.sortByColumn}
                                        />
                                    ) : (
                                        <h4 className={'text-center'}>
                                            {I18nUtils.tr('TR_SELECCIONE_LOS_PARAMETROS_DE_BUSQUEDA')}
                                        </h4>
                                    )
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Row>
                <ConfirmModal
                    show={showCreateTaskConfirmModal}
                    onHide={this.hideCreateTaskConfirmModal}
                    onAccept={this.handleFetchCreateTask}
                    title={I18nUtils.tr('TR_GENERAR_TAREA')}
                    bodyText={I18nUtils.tr('TR_SE_VA_A_GENERAR_UNA_NUEVA_TAREA')}
                />
            </React.Fragment>
        );
    }

    fetchYears = () => {
        const request = new YearListRequest();

        new YearListTask(request)
            .onSuccess(res => {
                const years = res.data.map((year) => ( { value: year, name: year } ));
                this.setState({ years });
            })
            .execute();
    };

    fetchMonths = (year) => {
        const request = new MonthListRequest();

        request.setYear(year);

        new MonthListTask(request)
            .onSuccess(res => this.setState({ months: res.data }))
            .execute();
    };

    searchMonthlyPresences = () => {
        const { filters } = this.state;

        if ( !filters.canSearch() ) return;

        const request = new MonthlyPresenceSearchRequest();

        request.setConstructionId(filters.work());
        request.setYear(filters.year());
        request.setMonth(filters.month());
        request.setCompanyId(filters.outsource());
        request.setTerm(filters.search());

        new MonthlyPresenceSearchTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onPostExecution(() => this.setState({ loading: false }))
            .onSuccess(res => {
                const { sorting } = this.state;
                const { presences, days } = res.data;
                const presencesByMonth = PsPresence.presencesByMonth(presences ? presences : []);

                this.setState({
                    days,
                    presences: this.sortPresences(presencesByMonth, sorting),
                });
            })
            .execute();
    };

    selectYearFilter = (event) => {
        const { filters } = this.state;
        const nextYear = Number(event.target.value);
        const nextFilters = filters.clone();

        if ( filters.yearHasChanged(nextYear) ) {
            this.fetchMonths(nextYear);
        }

        nextFilters.clearMonth();
        nextFilters.clearOutsource();
        nextFilters.clearWork();
        nextFilters.setYear(nextYear);

        this.setState({ filters: nextFilters, presences: [] });
    };

    selectMonthFilter = (event) => {
        const { filters } = this.state;
        const nextMonth = Number(event.target.value);
        const nextFilters = filters.clone();

        nextFilters.clearOutsource();
        nextFilters.clearWork();
        nextFilters.setMonth(nextMonth);

        this.setState({ filters: nextFilters, presences: [] });
    };

    selectWorkFilter = (nextWork) => {
        const { filters } = this.state;
        const nextFilters = filters.clone();

        if ( nextWork ) nextFilters.setWork(nextWork.id);
        else nextFilters.clearWork();

        this.setState({ filters: nextFilters });
    };

    selectOutsourceFilter = (nextOutsource) => {
        const { filters } = this.state;
        const nextFilters = filters.clone();

        if ( nextOutsource ) nextFilters.setOutsource(nextOutsource.id);
        else nextFilters.clearOutsource();

        this.setState({ filters: nextFilters });
    };

    sortByColumn = (column) => {

        const { sorting, presences } = this.state;

        const nextSorting = sorting.clone();

        if ( nextSorting.isColumnSelected(column) ) nextSorting.changeOrientation(column);
        else nextSorting.selectColumn(column);

        this.setState({
            sorting: nextSorting,
            presences: this.sortPresences(presences, nextSorting),
        });
    };

    search = (nextSearch) => {
        const { filters } = this.state;
        const nextFilters = filters.clone();

        nextFilters.setSearch(nextSearch);

        this.setState({ filters: nextFilters });
    };

    sortPresences = (presences, sorting) => {
        if ( sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_DNI) ) {
            return PsPresence.sortPresencesByWorkerDni(
                presences,
                sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_DNI),
            );
        }
        if ( sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_NAME) ) {
            return PsPresence.sortPresencesByWorkerName(
                presences,
                sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_NAME),
            );
        }
        if ( sorting.isColumnSelected(MonthlyPresenceSorting.WORKER_COMPANY) ) {
            console.info('WORKER COMPANY SELECTED !')
            return PsPresence.sortPresencesByWorkerCompany(
                presences,
                sorting.isColumnOrientationAsc(MonthlyPresenceSorting.WORKER_COMPANY),
            );
        }
    };

    download = () => {
        this.setState({ moreOptionSelected: OptionsMore.DOWNLOAD });

    };

    handleFetchDownload = () => {
        const { filters } = this.state;
        const requestBody = new MonthlyPresenceDownloadRequest(
            filters.year(),
            filters.month(),
            filters.outsource(),
            filters.work(),
        );

        const genericRequest = new GenericRequest(METHOD_POST, ApiEndpoints.MONTLY_WORK_CHECK_EXPORT);
        let headers = genericRequest.headers;
        const authToken = cookie.load(AUTH_TOKEN);
        if ( authToken ) {
            headers.Authorization = 'Bearer ' + cookie.load(AUTH_TOKEN);
        }
        const requestInit = {
            method: genericRequest.method,
            headers: headers,
            mode: 'cors',
            body: JSON.stringify(requestBody.body()),
        };
        this.setState({ loading: true });
        fetch(genericRequest.url, requestInit)
            .then(response => {
                this.setState({ loading: false });
                response.blob().then(function(myBlob) {
                    const url = URL.createObjectURL(myBlob);
                    window.open(url, '_blank');
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                Alert.error(error || I18nUtils.tr('TR_ERROR_AL_EXPORTAR_EL_PDF'));
            });
    };

    handleFetchCreateTask = () => {
        const { filters } = this.state;
        const taskCreateRequest = new TaskCreateRequest(
            {
                year: filters.year(),
                month: filters.month(),
                constructionId: filters.work(),
                companyId: filters.outsource(),
            },
        );
        new TaskCreateTask(taskCreateRequest)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_TAREA_GENERADA_CORRECTAMENTE'));
                this.hideCreateTaskConfirmModal();
            })
            .onFail(error => {
                Alert.error(error);
                this.hideCreateTaskConfirmModal();
            })
            .execute();
    };

    moreOptions() {
        const { currentUser } = this.props;
        const {
            filters,
            moreOptionSelected,
        } = this.state;

        if ( !( currentUser.isAdmin() || currentUser.isOutsourcesManager() ) ) return [];

        return [
            {
                id: 'download',
                title: I18nUtils.tr('TR_DOWNLOAD'),
                active: moreOptionSelected === OptionsMore.DOWNLOAD,
                disabled: !filters.canDownload(),
                onClick: this.handleFetchDownload,
            },
            {
                id: 'createTask',
                title: I18nUtils.tr('TR_GENERAR_TAREA'),
                active: moreOptionSelected === OptionsMore.CREATE_TASK,
                disabled: !filters.canCreateTask(),
                onClick: this.showCreateTaskConfirmModal,
            },
        ];
    }

}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

export const MonthlyPresenceCard = connect(mapStateToProps)(MonthlyPresence);







// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/MonthlyPresenceCard.jsx